<template>
    <div v-show="show" class="common-popup-bg">
        <div class="common-popup">
            <h3>参数设置</h3>
            <el-form>
                <table class="common-popup-table">
                    <tr>
                        <td>俱乐部：</td>
                        <td v-text="`${configForm.clubName}(${configForm.clubRandomId})`"></td>
                    </tr>
                    <tr>
                        <td>占成率：</td>
                        <td>
                            <el-radio-group v-model="configForm.profit">
                                <el-radio :label="configForm.defaultProfit"><span
                                        v-text="`${configForm.defaultProfit}%`"></span></el-radio>
                                <el-radio :label="profitVal">自定义
                                  <el-input
                                      size="medium"
                                      type="number"
                                      suffix-icon="icon-percent"
                                      v-model.number="profitVal"/>
                                </el-radio>
                            </el-radio-group>
                        </td>
                    </tr>
                    <tr>
                        <td>联盟：</td>
                        <td>
                            <el-radio-group
                                v-model="configForm.tribeId">
                                <el-radio :label="configForm.defaultTribeId"><span v-text="configForm.tribeName"></span>
                                </el-radio>
                                <el-radio :label="tribeIdVal">自定义
                                    <el-select
                                            v-model="tribeIdVal"
                                            size="medium"
                                            filterable
                                            placeholder="请选择">
                                        <el-option
                                                v-for="item in allUnionList"
                                                :key="item.id"
                                                :label="item.tribeName"
                                                :value="item.id"/>
                                    </el-select>
                                </el-radio>
                            </el-radio-group>
                        </td>
                    </tr>
                    <tr>
                        <td>联系方式：</td>
                        <td v-text="configForm.contact"></td>
                    </tr>
                  <tr>
                    <td>联盟比例：</td>
                    <td v-text="`${configForm.nowTribeProfit} %`"
                        v-bind="getTribeProfit(configForm.tribeId)"></td>
                  </tr>
                    <tr v-if="!configForm.transType">
                        <td>战绩返佣：</td>
                        <td>
                            <el-switch
                                    v-model="configForm.openRebate"
                                    :active-value="1"
                                    :inactive-value="0"/>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left" colspan="2">重置修改交易模式时间：
                            <el-switch
                                    v-model="resetTransTypeTime"
                                    :active-value="1"
                                    :inactive-value="0"/>
                        </td>
                    </tr>
                </table>
            </el-form>
            <footer>
                <el-button size="small" @click="show = false">取消</el-button>
                <el-button size="small" type="primary" @click="submitConfig">确定</el-button>
            </footer>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            info: Object
        },
        data() {
            return {
                show: false,
                profitVal: '',
                tribeIdVal: '',
                configForm: {},
                resetTransTypeTime: 0,//重置修改交易模式时间
            }
        },
        computed: {
            ...mapState('union', ['allUnionList']),
        },
        created() {
            this.getAllUnionList();
        },
        watch: {
            info(newVal){
                if (!newVal) return;
                this.profitVal = '';
                this.tribeIdVal = '';
                this.resetTransTypeTime = 0;
                this.configForm = {
                    clubName: newVal.clubName,
                    id: newVal.id,
                    clubRandomId: newVal.clubRandomId,
                    profit: newVal.profit,
                    defaultProfit: newVal.profit,
                    tribeId: newVal.tribeId,
                    defaultTribeId: newVal.tribeId,
                    tribeName: newVal.tribeName,
                    nowTribeProfit:this.getTribeProfit(this.configForm.tribeId),
                    contact: newVal.contact,
                    openRebate: newVal.openRebate,
                    transType: newVal.transType
                }
            },
            profitVal(newVal) {
                if (!newVal) return;
                this.configForm.profit = newVal
            },
            tribeIdVal(newVal) {
                if (!newVal) return;
                this.configForm.tribeId = newVal
            }
        },
        methods: {
            ...mapActions('club', ['updateClubConfig']),
            ...mapActions('union', ['getAllUnionList','getTribeProfitAPI']),
            getTribeProfit(val){
              if (val===undefined) {
                return
              }
              this.getTribeProfitAPI({
                tribeId:val
              }).then(res => {
                 this.configForm.nowTribeProfit=res.data==null?0:res.data;
              }).catch(()=>{
                alert("请求失败")
              })
            },
            // 提交修改
            submitConfig: function () {
                const {id, profit, defaultProfit, tribeId, defaultTribeId, openRebate} = {...this.configForm};
                if (!profit) {
                    this.$message.error('请设置占成率');
                    return
                }
                if (!tribeId) {
                    this.$message.error('请选择联盟');
                    return
                }
                let params = {
                    clubId: id,
                    resetTransTypeTime: this.resetTransTypeTime,
                    openRebate
                };
                if (profit !== defaultProfit) {
                    params.profit = profit
                }

                    params.tribeId = tribeId
                
                this.updateClubConfig(params).then(() => {
                    this.$emit('my-submit');
                    this.show = false;
                    this.$message.success('修改成功');
                })
            },
        }
    }
</script>